// extracted by mini-css-extract-plugin
export default {"cwc-title":"TitleWithImg_cwc-title__EFT4I"};